import { AsyncSubject } from '../AsyncSubject';
import { ConnectableObservable } from '../observable/ConnectableObservable';
export function publishLast() {
    var subject = new AsyncSubject();
    return function (source) { return new ConnectableObservable(source, function () { return subject; }); };
}
//# sourceMappingURL=publishLast.js.map